export default __webpack_public_path__ + "static/media/shipping.1f7b9ffa.jpg";